import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import appReducer from './appSlice';
import authReducer from './authSlice';
import treeReducer from '../components/familytree/scripts/tree-slice';
import modalReducer from './modalSlice';
import notiReducer from '../container/views/email-notification/noti-template-slice';
import userManagementReducer from '../container/views/user-management/user-management-slice';
import rolesAndPermissionManagementSlice from '../container/views/user-management/roles-and-permission-management-slice';

const rootReducer = {
  app: appReducer,
  auth: authReducer,
  tree: treeReducer,
  modal: modalReducer,
  user: userManagementReducer,
  noti: notiReducer,
  rolesPermission: rolesAndPermissionManagementSlice,
};
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(), //.concat(logger), // redux log, concat in Development mode
});
